import React from 'react';
import { FlatButtonContainer, FlatTextContainer } from './styled';

const FlatButton = ({
  children,
  arrowDirection,
  inverse,
  back,
  disabled,
  className = '',
  onClick,
  arrowSize = 5,
  margin,
  ...rest
}) => (
  <FlatButtonContainer
    back={back}
    inverse={inverse}
    role="button"
    className={`${className} ${disabled ? 'disabled' : ''}`}
    onClick={e => {
      if (!disabled && onClick) {
        onClick(e);
      }
    }}
    data-testid="flatbutton"
    arrowSize={arrowSize}
    arrowDirection={arrowDirection}
    margin={margin}
    {...rest}
  >
    <FlatTextContainer back={back} inverse={inverse}>
      {children}
    </FlatTextContainer>
  </FlatButtonContainer>
);

export default FlatButton;
